export { default as EntryController } from './EntryController';
